export class ValidDateOption {
  constructor() {
    this.isValidDate = true;
    this.isValidDay = true;
    this.isValidMonth = true;
    this.isValidYear = true;
    this.errorMessage = '';
  }
  isValidDay: boolean;
  isValidMonth: boolean;
  isValidYear: boolean;
  isValidDate: boolean;
  errorMessage: string;
}
